module.exports = __webpack_public_path__ + "static/potomac-54eb754fe783e672f5e0145c103b6ab2.png";